/**
 * Hydrates same-brand PDP rail — merges brand collections + full catalog by vendor.
 */
(function () {
  var JSON_LIMIT = 250;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, page) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      JSON_LIMIT +
      '&page=' +
      page;
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function fetchAllProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      return fetch(collectionProductsJsonUrl(handle, page))
        .then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < JSON_LIMIT) return all;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function vendorKey(p) {
    return String((p && p.vendor) || '')
      .toLowerCase()
      .trim();
  }

  function collectionHasVendor(products, vendorKeyTarget) {
    for (var i = 0; i < products.length; i++) {
      if (vendorKey(products[i]) === vendorKeyTarget) return true;
    }
    return false;
  }

  function mergeHandles(products, opts) {
    var handles = opts.handles.slice();
    var seenHandle = Object.create(null);
    var i;
    for (i = 0; i < handles.length; i++) seenHandle[handles[i]] = true;

    for (i = 0; i < products.length && handles.length < opts.limit; i++) {
      var p = products[i];
      if (!p || !p.id || !p.handle) continue;
      if (opts.productId && p.id === opts.productId) continue;
      if (vendorKey(p) !== opts.vendorKey) continue;
      if (seenHandle[p.handle]) continue;
      seenHandle[p.handle] = true;
      handles.push(p.handle);
    }
    return handles;
  }

  function collectionHandlesToTry(root) {
    var list = [];
    var seen = Object.create(null);
    function add(h) {
      h = String(h || '').trim();
      if (!h || seen[h]) return;
      seen[h] = true;
      list.push(h);
    }
    add(root.dataset.brandHandle);
    var vh = root.dataset.vendorHandle;
    if (vh) {
      add(vh + '-1');
      add(vh);
      add(vh + '-2');
      add(vh + '-3');
      add('shop-' + vh);
      add(vh + '-shop');
      add('brand-' + vh);
    }
    add('all');
    return list;
  }

  function wakeSlider(root) {
    var sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;
    if (typeof sliderComponent.syncScrollPort === 'function') {
      sliderComponent.syncScrollPort();
    }
    if (typeof sliderComponent.initPages === 'function') {
      sliderComponent.initPages();
    }
    if (typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    }
  }

  function brandCollectionUrl(handle) {
    handle = String(handle || '').trim();
    if (!handle || handle === 'all') return '';
    var path = 'collections/' + encodeURIComponent(handle);
    var base = shopBaseUrl();
    try {
      return new URL(path, base).pathname;
    } catch (_e) {
      return '/' + path;
    }
  }

  function normalizeBrand(value) {
    return String(value || '')
      .toLowerCase()
      .trim();
  }

  function extractHandleFromHref(href) {
    var match = String(href || '').match(/\/collections\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function brandLinkHandlesToTry(root) {
    var list = [];
    var seen = Object.create(null);
    function add(h) {
      h = String(h || '').trim();
      if (!h || h === 'all' || seen[h]) return;
      seen[h] = true;
      list.push(h);
    }

    var link = root.querySelector('.skipp-pdp-more-from-brand__brand-link');
    var hrefHandle = link ? extractHandleFromHref(link.getAttribute('href')) : '';
    var vh = String(root.dataset.vendorHandle || '').trim();

    add(root.dataset.brandHandle);
    add(hrefHandle);
    if (vh) {
      add(vh + '-1');
      add(vh);
      add(vh + '-2');
      add(vh + '-3');
      add('shop-' + vh);
      add(vh + '-shop');
      add('brand-' + vh);
    }

    return list;
  }

  function probeCollectionForVendor(handle, vendorKeyTarget) {
    handle = String(handle || '').trim();
    if (!handle || handle === 'all') return Promise.resolve(false);

    return fetch(collectionProductsJsonUrl(handle, 1))
      .then(function (r) {
        if (!r.ok) return false;
        return r.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) return false;
        return collectionHasVendor(products, vendorKeyTarget);
      })
      .catch(function () {
        return false;
      });
  }

  function setBrandLink(root, collectionHandle) {
    var href = brandCollectionUrl(collectionHandle);
    if (!href) return;
    var link = root.querySelector('.skipp-pdp-more-from-brand__brand-link');
    if (!link) return;
    link.setAttribute('href', href);
    root.dataset.brandHandle = collectionHandle;
    delete root.dataset.skippBrandLinkPending;
  }

  function findBrandCollectionHandle(collections, vendorName, vendorHandle) {
    var vendorNorm = normalizeBrand(vendorName);
    var vh = String(vendorHandle || '').trim();
    var handleMatch = '';
    var partialTitleMatch = '';
    var i;

    for (i = 0; i < collections.length; i++) {
      var collection = collections[i];
      if (!collection || !collection.handle) continue;
      if (collection.handle === 'all' || collection.handle === 'frontpage') continue;

      var titleNorm = normalizeBrand(collection.title);
      if (vendorNorm && titleNorm === vendorNorm) {
        return collection.handle;
      }

      if (vh && collection.handle === vh + '-1') handleMatch = collection.handle;
      else if (vh && collection.handle === vh) handleMatch = collection.handle;
      if (vh && collection.handle === vh + '-2') handleMatch = collection.handle;
      if (vh && collection.handle === vh + '-3') handleMatch = collection.handle;
      if (vh && collection.handle === 'shop-' + vh) handleMatch = collection.handle;
      if (vh && collection.handle === vh + '-shop') handleMatch = collection.handle;
      if (vh && collection.handle === 'brand-' + vh) handleMatch = collection.handle;

      if (
        !partialTitleMatch &&
        vendorNorm &&
        titleNorm &&
        (titleNorm.indexOf(vendorNorm) !== -1 || vendorNorm.indexOf(titleNorm) !== -1)
      ) {
        partialTitleMatch = collection.handle;
      }
    }

    return handleMatch || partialTitleMatch || '';
  }

  var collectionsCatalogPromise = null;

  function fetchAllCollections() {
    if (collectionsCatalogPromise) return collectionsCatalogPromise;

    var all = [];
    var page = 1;

    function next() {
      var path = 'collections.json?limit=250&page=' + page;
      var base = shopBaseUrl();
      var url;
      try {
        url = new URL(path, base).href;
      } catch (_e) {
        url = '/' + path;
      }

      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('collections.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.collections || [];
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < 250) return all;
          page += 1;
          return next();
        });
    }

    collectionsCatalogPromise = next().catch(function () {
      collectionsCatalogPromise = null;
      return [];
    });
    return collectionsCatalogPromise;
  }

  function resolveBrandCollectionLink(root) {
    if (!root) return Promise.resolve();

    var vendorName = String(root.dataset.productVendor || '').trim();
    var vendorKeyTarget = normalizeBrand(vendorName);
    var vendorHandle = String(root.dataset.vendorHandle || '').trim();
    if (!vendorKeyTarget) return Promise.resolve();

    var handlesToTry = brandLinkHandlesToTry(root);

    function tryHandleWithDashOneFallback(handle, nextIndex) {
      handle = String(handle || '').trim();
      if (!handle) return tryNext(nextIndex);

      return probeCollectionForVendor(handle, vendorKeyTarget).then(function (ok) {
        if (ok) {
          setBrandLink(root, handle);
          return;
        }

        if (!/-1$/.test(handle)) {
          return probeCollectionForVendor(handle + '-1', vendorKeyTarget).then(function (okSuffix) {
            if (okSuffix) {
              setBrandLink(root, handle + '-1');
              return;
            }
            return tryNext(nextIndex);
          });
        }

        return tryNext(nextIndex);
      });
    }

    function tryNext(index) {
      if (index >= handlesToTry.length) {
        return fetchAllCollections().then(function (collections) {
          var handle = findBrandCollectionHandle(collections, vendorName, vendorHandle);
          if (!handle) return;
          return tryHandleWithDashOneFallback(handle, handlesToTry.length);
        });
      }
      return tryHandleWithDashOneFallback(handlesToTry[index], index + 1);
    }

    return tryNext(0);
  }

  function hydrate(root, handles) {
    if (!handles.length) return Promise.resolve();
    var sectionId = root.dataset.sectionId;
    var params = new URLSearchParams();
    params.set('section_id', sectionId);
    params.set('skipp_same_brand_handles', handles.join(','));
    var url = window.location.pathname + '?' + params.toString();
    return fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-skipp-same-brand]');
        if (!fresh) return;
        var slider = fresh.querySelector('[data-skipp-pdp-rail-slider]');
        if (!slider) return;
        var existing = root.querySelector('[data-skipp-pdp-rail-slider]');
        if (existing) {
          existing.replaceWith(slider);
        } else {
          root.appendChild(slider);
        }
        root.dataset.skippSameBrandReady = '1';
        wakeSlider(root);
        document.dispatchEvent(new CustomEvent('skipp:collection-delivery-split'));
      });
  }

  function init(root) {
    if (!root) return;

    var vendorKeyTarget = String(root.dataset.productVendor || '')
      .toLowerCase()
      .trim();
    var productId = parseInt(root.dataset.productId, 10);
    var sectionId = root.dataset.sectionId;
    var limit = parseInt(root.dataset.limit, 10) || 10;
    var cardCount = root.querySelectorAll('.product-grid .grid__item').length;

    if (!sectionId || !vendorKeyTarget) return;

    resolveBrandCollectionLink(root);

    if (root.dataset.skippSameBrandReady === '1') return;

    if (cardCount >= limit) {
      root.dataset.skippSameBrandReady = '1';
      wakeSlider(root);
      return;
    }

    var handles = [];
    var domItems = root.querySelectorAll('.product-grid .grid__item');
    for (var d = 0; d < domItems.length; d++) {
      var link = domItems[d].querySelector('a[href*="/products/"]');
      if (!link) continue;
      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (match && match[1]) handles.push(match[1]);
    }

    var tries = collectionHandlesToTry(root);
    var chain = Promise.resolve(handles);

    tries.forEach(function (collHandle) {
      chain = chain.then(function (acc) {
        if (acc.length >= limit) return acc;
        return fetchAllProducts(collHandle).then(function (products) {
          if (collHandle !== 'all' && collectionHasVendor(products, vendorKeyTarget)) {
            setBrandLink(root, collHandle);
          }
          return mergeHandles(products, {
            handles: acc,
            limit: limit,
            vendorKey: vendorKeyTarget,
            productId: productId,
          });
        });
      });
    });

    chain
      .then(function (finalHandles) {
        if (finalHandles.length > cardCount) {
          return hydrate(root, finalHandles);
        }
        if (cardCount > 0) {
          root.dataset.skippSameBrandReady = '1';
          wakeSlider(root);
        }
      })
      .catch(function () {
        if (cardCount > 0) {
          wakeSlider(root);
        }
      });
  }

  function boot() {
    document.querySelectorAll('[data-skipp-same-brand]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
